/* GENERATED by scripts/fetch-lpc.mjs — do not edit by hand.
   (The type annotation below is hand-written; the generator emits the data.) */

/** The three recolourable materials. Every sheet is drawn in one of these
    materials' `$base` ramp and swapped pixel-for-pixel into another. */
export type Material = "skin" | "hair" | "cloth";

/** ramp id → the six authored colours, darkest first. */
type Ramps = Record<string, string[]>;

export const PALETTES: Record<Material, Ramps> = {
  "skin": {
    "$base": [
      "#271920",
      "#99423c",
      "#cc8665",
      "#E4A47C",
      "#F9D5BA",
      "#FAECE7"
    ],
    "light": [
      "#271920",
      "#99423c",
      "#cc8665",
      "#E4A47C",
      "#F9D5BA",
      "#FAECE7"
    ],
    "amber": [
      "#281716",
      "#9E3E37",
      "#D28144",
      "#EA9F54",
      "#FDD082",
      "#FBE7A4"
    ],
    "olive": [
      "#271920",
      "#442725",
      "#7F4C31",
      "#AE6B3F",
      "#D38B59",
      "#E4A47C"
    ],
    "taupe": [
      "#271920",
      "#503734",
      "#785946",
      "#936849",
      "#BA8454",
      "#C7935F"
    ],
    "bronze": [
      "#1A1213",
      "#442725",
      "#644133",
      "#7F4C31",
      "#AE6B3F",
      "#D38B59"
    ],
    "brown": [
      "#120E10",
      "#412B29",
      "#5F4539",
      "#76513A",
      "#9C663E",
      "#B8773F"
    ],
    "black": [
      "#000000",
      "#1A1213",
      "#2E1F1C",
      "#442725",
      "#603429",
      "#7F4C31"
    ],
    "blue": [
      "#16171B",
      "#46425D",
      "#586B90",
      "#748DA4",
      "#A9C9CA",
      "#C8E8E8"
    ],
    "green": [
      "#140C09",
      "#09320B",
      "#19541D",
      "#228236",
      "#39AA4E",
      "#53BF71"
    ],
    "bright_green": [
      "#02280E",
      "#06410E",
      "#255E1D",
      "#5B8F11",
      "#75AE23",
      "#99D248"
    ],
    "dark_green": [
      "#011708",
      "#02280E",
      "#06410E",
      "#255E1D",
      "#508A48",
      "#509E59"
    ],
    "pale_green": [
      "#271920",
      "#314829",
      "#456238",
      "#5F874D",
      "#86B278",
      "#ADCCA6"
    ],
    "lavender": [
      "#16171B",
      "#393B44",
      "#787C8F",
      "#A0A5BC",
      "#C9D0EE",
      "#FBECE6"
    ]
  },
  "hair": {
    "$base": [
      "#260D14",
      "#6A1108",
      "#A42600",
      "#BF4000",
      "#E55600",
      "#FF8A00"
    ],
    "black": [
      "#000000",
      "#080A0A",
      "#101414",
      "#1C2222",
      "#31313E",
      "#4A5057"
    ],
    "raven": [
      "#010107",
      "#040B18",
      "#061421",
      "#071F2A",
      "#0D384D",
      "#1A5369"
    ],
    "dark_brown": [
      "#050100",
      "#160701",
      "#290E02",
      "#421603",
      "#5F1F04",
      "#792806"
    ],
    "chestnut": [
      "#200C0D",
      "#3A130E",
      "#63200B",
      "#81310A",
      "#B6550E",
      "#D28102"
    ],
    "light_brown": [
      "#1A0E04",
      "#301B07",
      "#60350F",
      "#7D4513",
      "#AE682A",
      "#C88D58"
    ],
    "sandy": [
      "#1C0E06",
      "#633E2C",
      "#99622D",
      "#BF9D5A",
      "#EDDC7E",
      "#F6F6C2"
    ],
    "blonde": [
      "#331313",
      "#552B15",
      "#AC5D1F",
      "#E09E2B",
      "#FCCF56",
      "#FFE67D"
    ],
    "platinum": [
      "#1C0E06",
      "#7D5D5D",
      "#A87D52",
      "#C0AB81",
      "#EDDF95",
      "#F6F6F3"
    ],
    "white": [
      "#1D1D21",
      "#484E57",
      "#8B9498",
      "#B8BBBC",
      "#D8DCDC",
      "#FFFFFF"
    ],
    "ash": [
      "#2D061B",
      "#642442",
      "#935065",
      "#C18F8A",
      "#EDDF95",
      "#FFF1C1"
    ],
    "gray": [
      "#0E0E0E",
      "#292929",
      "#4B4B4B",
      "#777777",
      "#AAAAAA",
      "#D9D9D9"
    ],
    "ginger": [
      "#300500",
      "#6A1A00",
      "#9C3B01",
      "#CC6901",
      "#FAA301",
      "#FFE01E"
    ],
    "carrot": [
      "#5A1500",
      "#8A2000",
      "#AC2800",
      "#EC673E",
      "#F68764",
      "#FFB39C"
    ],
    "redhead": [
      "#260D14",
      "#3E111A",
      "#73171E",
      "#9E1F1F",
      "#C7341B",
      "#E74716"
    ],
    "red": [
      "#300000",
      "#870000",
      "#A40712",
      "#CB0000",
      "#E21414",
      "#F1583A"
    ],
    "rose": [
      "#30051F",
      "#6A1E4B",
      "#9C4373",
      "#CC789D",
      "#FABBC6",
      "#FAE1E5"
    ],
    "pink": [
      "#330410",
      "#71043A",
      "#B60A68",
      "#E941AA",
      "#E976C4",
      "#EA95D5"
    ],
    "purple": [
      "#13112D",
      "#2B225A",
      "#402E82",
      "#7141B2",
      "#A966DD",
      "#D085ED"
    ],
    "violet": [
      "#1E032E",
      "#30035C",
      "#380392",
      "#3C07D8",
      "#5662F3",
      "#5792F2"
    ],
    "navy": [
      "#180716",
      "#20102B",
      "#281E41",
      "#322D6A",
      "#3C49AD",
      "#466AC9"
    ],
    "blue": [
      "#000027",
      "#00005E",
      "#000091",
      "#0041B4",
      "#0074CB",
      "#1E85EF"
    ],
    "green": [
      "#000400",
      "#001400",
      "#002D00",
      "#005000",
      "#007C00",
      "#00A700"
    ]
  },
  "cloth": {
    "$base": [
      "#281820",
      "#4D4A5D",
      "#958080",
      "#C4B59F",
      "#E5E6C7",
      "#FFFFFF"
    ],
    "white": [
      "#281820",
      "#4D4A5D",
      "#958080",
      "#C4B59F",
      "#E5E6C7",
      "#FFFFFF"
    ],
    "black": [
      "#000000",
      "#101414",
      "#1C2222",
      "#22282A",
      "#2A3034",
      "#4A5057"
    ],
    "charcoal": [
      "#000000",
      "#130D14",
      "#1C2222",
      "#2A3034",
      "#4A5057",
      "#6E7675"
    ],
    "slate": [
      "#1d131e",
      "#31313E",
      "#4A5057",
      "#818B8B",
      "#B3AFA1",
      "#E5E6C7"
    ],
    "gray": [
      "#0e0e18",
      "#201E2B",
      "#373340",
      "#585561",
      "#797580",
      "#A2A0A4"
    ],
    "navy": [
      "#180716",
      "#20102B",
      "#281E41",
      "#322D6A",
      "#3C49AD",
      "#466AC9"
    ],
    "blue": [
      "#180716",
      "#281E41",
      "#322D6A",
      "#3C49AD",
      "#466AC9",
      "#61A0EF"
    ],
    "sky": [
      "#1a0d18",
      "#313148",
      "#586B90",
      "#9FBBCB",
      "#C6EEFD",
      "#FFFFFF"
    ],
    "teal": [
      "#180716",
      "#1B2B47",
      "#0E4E72",
      "#156C99",
      "#0098B2",
      "#00CFDF"
    ],
    "forest": [
      "#09131d",
      "#07391D",
      "#0B1F25",
      "#0B2B28",
      "#134507",
      "#1B5502"
    ],
    "green": [
      "#101820",
      "#192832",
      "#0B5C2F",
      "#214437",
      "#2F8136",
      "#64A42C"
    ],
    "maroon": [
      "#1d131e",
      "#400B1F",
      "#551C22",
      "#682121",
      "#832121",
      "#AE424A"
    ],
    "red": [
      "#1d131e",
      "#400B1F",
      "#651117",
      "#82171C",
      "#AB1E1E",
      "#CD2429"
    ],
    "rose": [
      "#1d131e",
      "#301723",
      "#562323",
      "#77372B",
      "#8A3D28",
      "#B05F3C"
    ],
    "pink": [
      "#1d131e",
      "#54242E",
      "#6C3536",
      "#AE424A",
      "#C36072",
      "#E08080"
    ],
    "purple": [
      "#180716",
      "#13112D",
      "#261044",
      "#411357",
      "#621E78",
      "#813089"
    ],
    "lavender": [
      "#13112d",
      "#2B225A",
      "#402E82",
      "#7141B2",
      "#A966DD",
      "#D085ED"
    ],
    "orange": [
      "#301723",
      "#5F1D1B",
      "#9C3F23",
      "#D75B1A",
      "#EF7E19",
      "#FFA749"
    ],
    "yellow": [
      "#301723",
      "#5F2F25",
      "#BA5B23",
      "#D99431",
      "#F3C03F",
      "#FFE360"
    ],
    "tan": [
      "#3e2613",
      "#684415",
      "#986A20",
      "#B78C41",
      "#B7996A",
      "#CFC587"
    ],
    "brown": [
      "#1d131e",
      "#411E05",
      "#4B2B13",
      "#62351C",
      "#744B30",
      "#996B4A"
    ],
    "leather": [
      "#2b1c1d",
      "#311210",
      "#4B2B13",
      "#704325",
      "#75502D",
      "#9A6F37"
    ],
    "walnut": [
      "#1d0f0e",
      "#3e2613",
      "#62351c",
      "#744b30",
      "#996b4a",
      "#a17c50"
    ],
    "bluegray": [
      "#11150b",
      "#0B2B28",
      "#2E403A",
      "#315B49",
      "#557E85",
      "#79979D"
    ]
  }
};

export const SKIN_HUMAN = ["light","amber","olive","taupe","bronze","brown","black"];
export const SKIN_AGENT = ["blue","green","bright_green","dark_green","pale_green","lavender"];
export const HAIR_COLORS = ["black","raven","dark_brown","chestnut","light_brown","sandy","blonde","platinum","white","ash","gray","ginger","carrot","redhead","red","rose","pink","purple","violet","navy","blue","green"];
export const CLOTH_COLORS = ["white","black","charcoal","slate","gray","navy","blue","sky","teal","forest","green","maroon","red","rose","pink","purple","lavender","orange","yellow","tan","brown","leather","walnut","bluegray"];
